import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-screen background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20featuring%20diverse%20fashion%20and%20lifestyle%20products%20including%20sneakers%20leather%20goods%20watches%20sunglasses%20and%20fragrance%20bottles%20arranged%20in%20an%20organic%20artistic%20composition%20on%20a%20dark%20charcoal%20slate%20surface%20with%20dramatic%20rim%20lighting%20and%20deep%20shadows%20modern%20luxury%20aesthetic%20with%20metallic%20accents%20and%20rich%20texture%20contrast%20high%20end%20magazine%20spread%20style&width=1920&height=1080&seq=hero-flatlay-v2-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet - Agent Shopping Product Collection"
        title="CSSBuy Spreadsheet Agent Shopping Product Collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchPriority="high"
      />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50" />

      {/* Centered content */}
      <div className="relative z-10 w-full max-w-3xl px-6 md:px-12 pt-28 pb-12 text-center">
        <span className="inline-block px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 mb-6 whitespace-nowrap">
          CSSBuy Spreadsheet System 2026
        </span>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-6">
          The Smartest Way<br />To Buy With Agents
        </h1>
        <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-8 max-w-xl mx-auto">
          Discover how thousands of users save money using <strong>CSSBuy spreadsheet</strong>, <strong>Kakobuy spreadsheet</strong>, <strong>Superbuy spreadsheet</strong>, and <strong>Oopbuy spreadsheet</strong> systems for fast, safe, and optimized agent shopping.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group px-8 py-4 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
          >
            Access Spreadsheet System Hub
            <span className="w-7 h-7 rounded border border-background-50/30 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </span>
          </a>
          <Link
            to="/articles/cssbuy-sheet-complete-guide"
            className="px-8 py-4 border-2 border-background-50 text-background-50 rounded-md text-sm font-semibold hover:bg-background-50/10 transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
          >
            Read Full Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}